import type { BrandConfig } from "../../config/types.ts";
import { getActiveBrand } from "./resolver.ts";

export interface ZudokuThemeConfig {
  light: {
    primary?: string;
    primaryForeground?: string;
    secondary?: string;
    secondaryForeground?: string;
    background?: string;
    foreground?: string;
    card?: string;
    cardForeground?: string;
    popover?: string;
    popoverForeground?: string;
    muted?: string;
    mutedForeground?: string;
    accent?: string;
    accentForeground?: string;
    border?: string;
    ring?: string;
    radius?: string;
  };
  dark: {
    primary?: string;
    primaryForeground?: string;
    secondary?: string;
    secondaryForeground?: string;
    background?: string;
    foreground?: string;
    card?: string;
    cardForeground?: string;
    popover?: string;
    popoverForeground?: string;
    muted?: string;
    mutedForeground?: string;
    accent?: string;
    accentForeground?: string;
    border?: string;
    ring?: string;
    radius?: string;
  };
}

/** Tema Zudoku derivado de la marca activa */
export function getZudokuThemeConfig(brandOrConfig?: BrandConfig): ZudokuThemeConfig {
  const brand = brandOrConfig || getActiveBrand();
  const primary = brand.colors.primary;
  const light = brand.colors.light ?? {};
  const dark = brand.colors.dark ?? {};
  const pick = (...candidates: Array<string | undefined>): string | undefined =>
    candidates.find((c) => c !== undefined && c !== "");

  return {
    light: {
      primary: pick(light.primary, primary),
      primaryForeground: pick(light.primaryForeground, brand.colors.primaryForeground, "#ffffff"),
      secondary: pick(light.secondary, brand.colors.secondary, light.muted, "#f1f5f9"),
      secondaryForeground: pick(light.secondaryForeground, brand.colors.secondaryForeground, "#0f172a"),
      background: pick(light.background, "#ffffff"),
      foreground: pick(light.foreground, "#0f172a"),
      card: pick(light.card, "#ffffff"),
      cardForeground: pick(light.cardForeground, "#0f172a"),
      popover: pick(light.popover, "#ffffff"),
      popoverForeground: pick(light.popoverForeground, "#0f172a"),
      muted: pick(light.muted, "#f8fafc"),
      mutedForeground: pick(light.mutedForeground, "#64748b"),
      border: pick(light.border, "#e2e8f0"),
      ring: pick(light.ring, primary),
      accent: pick(brand.colors.accent, primary),
      accentForeground: pick(light.accentForeground, "#ffffff"),
      radius: pick(light.radius, "0.5rem"),
    },
    dark: {
      primary: pick(dark.primary, brand.colors.accent, primary),
      primaryForeground: pick(dark.primaryForeground, "#ffffff"),
      secondary: pick(dark.secondary, brand.colors.secondary, dark.muted, "#1e293b"),
      secondaryForeground: pick(dark.secondaryForeground, brand.colors.secondaryForeground, "#f8fafc"),
      background: pick(dark.background, "#09090b"),
      foreground: pick(dark.foreground, "#f8fafc"),
      card: pick(dark.card, "#09090b"),
      cardForeground: pick(dark.cardForeground, "#f8fafc"),
      popover: pick(dark.popover, "#09090b"),
      popoverForeground: pick(dark.popoverForeground, "#f8fafc"),
      muted: pick(dark.muted, "#18181b"),
      mutedForeground: pick(dark.mutedForeground, "#a1a1aa"),
      border: pick(dark.border, "#27272a"),
      ring: pick(dark.ring, primary),
      accent: pick(brand.colors.accent, primary),
      accentForeground: pick(dark.accentForeground, "#ffffff"),
      radius: pick(dark.radius, "0.5rem"),
    },
  };
}